(function ($) {

  $('#block-mainnavigation > ul > li > a, #block-mainnavigation > ul > li > span').each(function() {
    const menuLink = $(this);
    const menuEntry = menuLink.parent();
    const subEntry = menuEntry.find('ul');
    if (subEntry.length >= 1) {
      menuEntry.attr('data-height', menuEntry.height());
      menuEntry.addClass('closed');
      menuLink.on('click', function(event) {
        event.preventDefault();
        if (menuEntry.hasClass('closed')) {
          menuEntry.css('max-height', menuEntry.attr('data-height') + 'px');
          menuEntry.removeClass('closed');
        } else {
          menuEntry.css('max-height', 50).addClass('closed');
        }
      });
    }
  });

  $('#menu-toggle').on('click', function() {
    $('.menu-overlay').toggleClass('visible');
    $('body, html').toggleClass('noscroll');
    $(this).find('svg').toggleClass('hidden');
  });

  $(document).ready(() => {
    // Display the back button only if it navigates back to the same domain.
    if (document.referrer.indexOf(window.location.host) === -1) {
      $('.news-back-button').addClass('hidden');
    }
  });

})(jQuery);
